import React from "react";
import { Button, Modal } from "react-bootstrap";

function ErrorPopup({ show, popupMssg, title, handleClose = () => {}, isOptionalPopup }) {
  return (
    <Modal backdrop="static" show={show} onHide={handleClose} centered>
      {/* <Modal.Header closeButton>
        <Modal.Title>{title ? title : "Decline Report"} </Modal.Title>
      </Modal.Header> */}

      <Modal.Body>
        <div className="popupTxtArea">
          <p>{popupMssg}</p>
        </div>
      </Modal.Body>

      <Modal.Footer style={{ justifyContent: "center" }}>
        <div className=" text-center">
          <Button variant="secondary" onClick={() => handleClose()}>
            {isOptionalPopup ? "Ok" : "Close"}
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}

export default ErrorPopup;
